import Button from "@common/components/Button";
import Grid from '@mui/material/Grid2';
import { RoomsRealtimeContext } from "@common/components/ListDetailViews/Layout/context";
import RightDrawer from "@common/components/RightDrawer";
import Select from "@common/components/Select";
import { MenuItem, TextField } from "@mui/material";
import { extendMeeting } from "@services/meetings";
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ExtendDurationItems } from "./const";
import { useErrorNotification } from "@common/components/Notification";

type ExtendDurationDrawerProps = {
  open: boolean;
  setOpen: Function;
};

const ExtendDurationDrawer = (props: ExtendDurationDrawerProps) => {
  const { t } = useTranslation();
  const dispatchError = useErrorNotification();
  const context = React.useContext(RoomsRealtimeContext);
  const { meeting } = { ...context.detail };
  const { open, setOpen } = props;

  const [extendDuration, setExtendDuration] = useState<{
    hours?: string;
    minutes?: string;
  }>({ hours: "0", minutes: "20" });

  const [duration, setDuration] = useState<string>("");
  const [customDuration, setCustomDuration] = useState<{
    hours?: string;
    minutes?: string;
  }>({ hours: undefined, minutes: undefined });
  const [loading, setLoading] = useState<boolean>(false);
  const disabledSubmit = () => {
    return duration === "other" &&
      !customDuration.hours &&
      !customDuration.minutes
      ? true
      : false;
  };
  useEffect(() => {
    const temp =
      ExtendDurationItems.find((item) => item.default === true) ??
      ExtendDurationItems[0];
    setDuration(temp.key);
  }, []);

  const onSubmit = async () => {
    setLoading(true);
    try {
      let end = meeting?.end;

      if (end) {
        if (duration !== "other") {
          let temp =
            (parseInt(extendDuration.hours ?? "0") * 60 +
              parseInt(extendDuration.minutes ?? "0")) *
            60000;
          await extendMeeting(meeting?.id, end + temp);
          await context.detail?.refetch();
        } else {
          let temp =
            (parseInt(customDuration.hours ?? "0") * 60 +
              parseInt(customDuration.minutes ?? "0")) *
            60000;

          await extendMeeting(meeting?.id, end + temp);
          await context.detail?.refetch();
        }
        setLoading(false);
        setOpen("");
      }
    } catch (e) {
      setLoading(false);
      dispatchError(e);
    }
  };

  const handleDurationChange = (value: string) => {
    setDuration(value);
    const temp = value !== "other" && value.split("-");

    if (!temp) return;
    temp[1] === "minutes"
      ? setExtendDuration({ minutes: temp[0] })
      : setExtendDuration({ hours: temp[0] });
  };

  const handleCustomDurationChange = (
    type: "hours" | "minutes",
    value: string
  ) => {
    if (Number(value) > -1) {
      setCustomDuration({ ...customDuration, [type]: value });
    } else {
      setCustomDuration({
        ...customDuration,
        [type]: 0,
      });
    }
  };

  return (
    <RightDrawer
      open={open}
      onClose={() => setOpen(false)}
      title={t("Extend Duration")}
      closeButton={
        <Grid
          sx={(theme) => ({
            "&>.MuiButton-root": { marginRight: theme.spacing(1) },
          })}>
          <Button
            color="white"
            onClick={onSubmit}
            loading={loading}
            disabled={disabledSubmit()}
          >
            Extend
          </Button>
          <Button
            color="greyed"
            variant="outlined"
            onClick={() => setOpen(false)}
          >
            Cancel
          </Button>
        </Grid>
      }
    >
      <Grid
        container
        direction="column"
        sx={{ width: '100%', alignItems: "center",
          gap: "1.5rem",
          paddingTop: "1rem",
          px: 2 }}>
        <Select
          defaultValue={ExtendDurationItems[0].key}
          label={t("Extend Meeting's Duration for")}
          value={duration}
          onChange={(event) =>
            handleDurationChange(event.target.value as string)
          }
        >
          {ExtendDurationItems.map((item) => (
            <MenuItem value={item.key} key={item.key}>
              {t(item.label, { value: item.value })}
            </MenuItem>
          ))}
          <MenuItem value={"other"}>{t("Other...")}</MenuItem>
        </Select>

        {duration === "other" && (
          <Grid
            container
            sx={{ width: '100%', flexDirection: "column",
              gap: 1 }}>
            <Grid>{t("Other Duration")}</Grid>
            <Grid
              sx={{
                width: "100%"
              }}>
              <Grid container sx={{ width: '100%', gap: 1 }}>
                <Grid
                  sx={{
                    flex: 1
                  }}>
                  <TextField
                    label={t("Hours")}
                    type="number"
                    fullWidth
                    value={customDuration.hours}
                    onChange={(e) =>
                      handleCustomDurationChange("hours", e.target.value)
                    }
                    slotProps={{
                      input: {
                        inputProps: { min: 0 },
                      }
                    }}
                  />
                </Grid>
                <Grid
                  sx={{
                    flex: 1
                  }}>
                  <TextField
                    label={t("Minutes")}
                    type="number"
                    fullWidth
                    value={customDuration.minutes}
                    onChange={(e) =>
                      handleCustomDurationChange("minutes", e.target.value)
                    }
                    slotProps={{
                      input: {
                        inputProps: { min: 0 },
                      }
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        )}
      </Grid>
    </RightDrawer>
  );
};

export default ExtendDurationDrawer;
